import React, { useId, useState } from 'react';
import { TRIAL } from './data';

const EARLY_RATE = TRIAL.early / TRIAL.churners;          // churners warned before the stop
const ALERTED_RATE = TRIAL.alerted / TRIAL.churners;      // churners alerted at all
const money = (v) => (v >= 1e6 ? `$${(v / 1e6).toFixed(v >= 1e7 ? 0 : 1)}M` : v >= 1e3 ? `$${Math.round(v / 1e3)}k` : `$${Math.round(v)}`);

function Slider({ label, value, min, max, step, onChange, format }) {
  const id = useId();
  const pct = ((value - min) / (max - min)) * 100;
  return (
    <div className="kz-roi-field">
      <label htmlFor={id}><span>{label}</span><output htmlFor={id}>{format(value)}</output></label>
      <input id={id} type="range" min={min} max={max} step={step} value={value}
        onChange={(e) => onChange(Number(e.target.value))} style={{ '--p': `${pct}%` }} />
    </div>
  );
}

// "Your numbers": the visitor's own assumptions multiplied by the trial's measured rates.
export default function Roi() {
  const [lost, setLost] = useState(40);
  const [value, setValue] = useState(120000);
  const [keep, setKeep] = useState(25);
  const warned = lost * EARLY_RATE;
  const kept = warned * (keep / 100);
  const retained = kept * value;
  const alerts = (lost * ALERTED_RATE) / TRIAL.precision;
  return (
    <div className="kz-roi">
      <div className="kz-roi-in">
        <h3>What earlier warning could be worth to you</h3>
        <p className="kz-roi-sub">Set your own assumptions. They are multiplied by the rates measured in blind trial #5a.</p>
        <Slider label="Customers you lose in a year" value={lost} min={5} max={400} step={5} onChange={setLost} format={(v) => v} />
        <Slider label="Average yearly revenue per customer" value={value} min={10000} max={1000000} step={10000} onChange={setValue} format={money} />
        <Slider label="Of those warned early, share your team could keep" value={keep} min={5} max={60} step={5} onChange={setKeep} format={(v) => `${v}%`} />
      </div>
      <div className="kz-roi-out" aria-live="polite">
        <div className="kz-roi-big">
          <span>Revenue kept per year</span>
          <b>{money(retained)}</b>
        </div>
        <dl>
          <div><dt>Warned before their orders stopped</dt><dd>{warned.toFixed(0)} <small>of {lost} ({Math.round(EARLY_RATE * 100)}% in the trial)</small></dd></div>
          <div><dt>Kept, at your rate</dt><dd>{kept.toFixed(1)} <small>customers</small></dd></div>
          <div className="is-cost"><dt>Customers flagged for review</dt><dd>{Math.round(alerts)} <small>about 4 in 5 of them stay anyway</small></dd></div>
        </dl>
        <p className="kz-roi-note">
          Not a forecast. Trial rates come from simulated worlds (5 worlds, 300 customers, 30 churners): {Math.round(ALERTED_RATE * 100)}% of churners were alerted,
          {' '}{Math.round(EARLY_RATE * 100)}% before the stop, and alert precision was {TRIAL.precision.toFixed(3)}.
        </p>
      </div>
    </div>
  );
}
